<template>
	<div class="schemelist">
		<el-card>
			<div>
				<el-row>
					<el-col :span="11">
						<span style="color:transparent" v-if="tips==''">1</span>
						<span v-if="tips!=''" style="color:#0066CC;font-size:13pt">{{tips}}</span>
					</el-col>
					<el-col :span="5">
						<el-select v-model="p_sort" filterable clearable placeholder="可按分类搜索" @change="refreshgrid(true)" size="mini" remote :remote-method="getsort">
						    <el-option
						      v-for="item in sortlist"
						      :key="item.p_sort"
						      :label="item.p_sort"
						      :value="item.p_sort">
						    </el-option>
						  </el-select>
					</el-col>
					<el-col :span="1" style="color:transparent">1</el-col>
					<el-col :span="5"><el-input placeholder="按商品名称搜索" v-model="searchbox" size="mini" @keyup.enter.native="refreshgrid(true)"></el-input></el-col>
					<el-col :span="2" style="text-align:right">
						<el-popover placement="bottom-end" :width="300" trigger="click">
							<table class="htmltable">
								<tr>
									<td><label>产品ID</label></td>
									<td><el-input type="textarea" v-model="searchlist.pkcno" size="mini"></el-input></td>
								</tr>
								<tr>
									<td><label>商品编号</label></td>
									<td><el-input type="textarea" v-model="searchlist.cno" size="mini"></el-input></td>
								</tr>
								<tr>
									<td><label>商品条码</label></td>
									<td><el-input type="textarea" v-model="searchlist.barcode" size="mini"></el-input></td>
								</tr>
								<tr>
									<td><label>商品名称</label></td>
									<td><el-input v-model="searchlist.cname" size="mini"></el-input></td>
								</tr>
								<tr>
									<td>商品品牌</td>
									<td><el-input type="text" v-model="searchlist.brand" size="mini"></el-input>
									</td>
								</tr>
								<tr>
									<td><label>语言类型</label></td>
									<td><el-select size="mini" v-model="searchlist.lang" placeholder="">
											<el-option :label="item.label" :value="item.value" v-for="(item, index) in langlist" :key="index"></el-option>
										</el-select></td>
								</tr>
								<tr>
									<td colspan="4" class="bottombtn">
										<el-button @click="refreshgrid(true)" type="warning" size="mini">查询</el-button>
										<el-button @click="ClearSearch" size="mini">清空</el-button>
									</td>
								</tr>
							</table>
						
							<el-link slot="reference" type="primary">更多筛选</el-link>
						</el-popover>
					</el-col>
				</el-row>
				<el-row style="height:10px;"></el-row>
				<el-row>
					<el-col :span="24">
						<tableui
							style="width:100%;"
							ref="cargolist"
							v-loading="loading"
							:tableData="cargolist"
							:columns="columns"
							@checkboxchange="checkboxchange"
							:gridheight="gridheight"
							@gridscroll="gridscroll"
						></tableui>
					</el-col>
				</el-row>
			</div>
			<div>
				<el-row>
					<el-col :span="12">
						<span>共 {{ count }} 条数据</span>
					</el-col>
				</el-row>
			</div>
		</el-card>
	</div>
</template>

<script>
import Utils from '../../lib/util.js';
import tableui from '@/components/table/tablegrid.vue';
export default {
	components: {
		tableui
	},
	data() {
		return {
			loading:false,
			columns:[],
			count:0,
			searchbox:'',
			gridheight:'300px',
			sort:'pkcno,cname',
			pageindex:0,
			pagesize:200,
			pagecount:1,
			mode:'商品编号列表',
			cargolist:[],
			checkedrow:[],
			selectedall:false,
			p_sort:'',
			sortlist:[],
			checktrigger:false,
			tips:'',
			checkedlist:[],
			searchlist:{
				pkcno:'',
				cno:'',
				barcode:'',
				cname:'',
				lang:'',
				brand:''
			},
			langlist:[]
		};
	},
	methods: {
		init(param){
			//debugger
			this.checkedlist=[];
			if(param.p_sort!=undefined)
				this.p_sort=param.p_sort;
			else
				this.p_sort='';
			if(param.searchbox!=undefined)
				this.searchbox=param.searchbox;
			else
				this.searchbox='';
			if(param.searchlist!=undefined)
			{
				if(param.searchlist!='')
					this.searchlist=param.searchlist;
				else
					this.ClearSearch();
			}
			else
				this.ClearSearch();
			if(param.gridheight!=undefined)
				this.gridheight=param.gridheight;
			if(param.checktrigger!=undefined)
				this.checktrigger=param.checktrigger;
			if(param.tips!=undefined)
				this.tips=param.tips;
			if(param.checkedlist!=undefined)
				this.checkedlist=param.checkedlist;
			this.GetColumns();
			this.getsort('');
			this.GetLanglist();
		},
		GetColumns() {
			var that = this;
			this.$apipost.get.GetColumns({ tab:'tab1', checkfield: 1, parentid:'', mode: this.mode, sys: '商城系统' }).then(res => {
				//console.log('列配置',JSON.stringify(res));
				that.columns = res;
				that.refreshgrid(true);
			});
		},
		GetLanglist(){
			//debugger
			var that = this;
			this.$apipost.get.dic({ type: '语言类型' }).then(res => {
				//debugger
				if (res.list != undefined) {
					that.langlist=res.list;
				}
			});
		},
		refreshgrid(isrefresh) {
			var that = this;
			var isload = true;
			if (isrefresh) {
				this.schemelist = [];
				this.checkedrow = [];
				//刷新
				this.pageindex = 0;
				this.selectedall = false;
			}
			else {
				//加载下一页
				if (parseInt(this.pagecount - 1) > this.pageindex) {
					this.pageindex = this.pageindex + 1;
				} else {
					isload = false;
				}
			}
			if (isload) {
				this.loading = true;
				var paraminfo = {
					mode: this.mode,
					tab: 'tab1',
					search: this.GetSearchObj(),
					pageindex: this.pageindex,
					pagesize: this.pagesize,
					sort: this.sort,
					iscount: 1,
					showcol: JSON.stringify(that.columns),
					sys: '商城系统'
				};
				//debugger
				this.$apipost.get.GetGridTable({ paraminfo: paraminfo }).then(res => {
					that.loading = false;
					if (res.data.length > 0) {
						if (that.pageindex > 0) {
							that.cargolist=that.cargolist.concat(res.data);
						} else {
							that.cargolist = res.data;
						}
					} else {
						that.cargolist = [];
					}
					that.setCargocnoChecked(that.checkedlist);
					that.count = res.count;
					that.pagecount=res.pagecount;
				});
			}
		},
		gridscroll(e) {
			if (e != undefined) {
				var that = this;
				const scrollDistance = e.event.target.scrollHeight - e.e.scrollTop - e.event.target.offsetHeight;
				if (scrollDistance <= 80) {
					that.refreshgrid(false);
				}
			}
		},
		GetSearchObj() {
			var search ={};
			search.searchlist=JSON.parse(JSON.stringify(this.searchlist));
			if (this.searchbox != '') {
				search.searchbox = this.searchbox;
			}
			if(this.p_sort!='')
				search.p_sort=this.p_sort;
			return JSON.stringify(search);
		},
		//复选框勾选触发
		checkboxchange(e) {
			var selall=false;
			//var checkedrows=JSON.parse(JSON.stringify(this.checkedrow));
			this.checkedrow=[];
			if (!e.selectedall) {
				if(e.selected){
					if(e.rows.length>0)
						this.checkedrow = e.rows; //勾选了的列表
					else
						selall=true;
				}else{
					this.checkedrow.push(e.row);
				}
			}
			else{
				selall=true;
				this.checkedrow=[];
			}
			this.selectedall = e.selectedall;
			if(this.checktrigger){
				//触发保存事件
				var paraminfo={mode: this.mode,
						tab: 'tab1',
						search:'',
						sort: this.sort,
						showcol: JSON.stringify(this.columns),
						sys: '商城系统'};
				//debugger
				if(selall)
					paraminfo.search=this.GetSearchObj();
				else
				{
					var pkcnos="",cnos="";
					if(this.checkedrow.length>0)
					{
						this.checkedrow.forEach(row=>{
							cnos+=row.cno+',';
							pkcnos+=row.pkcno+',';
						});
					}
					paraminfo.search={pkcno:pkcnos,cno:cnos};
				}
				if(this.selectedall)
					e.selected=true;
				this.checkchange({selectedall:this.selectedall,checkedrow:this.checkedrow,paraminfo:paraminfo,selected:e.selected});
			}
		},
		checkchange(e){
			this.$emit('checkchange',e);
		},
		getsort(val){
			var that = this;
			this.$apipost.get.GetCargoSort_Last({searchkey:val}).then(res => {
				that.sortlist = res.list;
			});
		},
		//设置默认选中
		setCargocnoChecked(list){
			var that = this;
			this.$refs.cargolist.$children[0].clearSelection();
			this.$nextTick(() => {
			    list.forEach(e => {
					that.cargolist.forEach(row=>{
						if(e.cno==row.cno&&e.pkcno==row.pkcno)
							that.$refs.cargolist.$children[0].toggleRowSelection([{row:row, selected:true}]);
				  });
			  });
			});
		},
		ClearSearch(){
			this.searchlist={
				pkcno:'',
				cno:'',
				barcode:'',
				cname:'',
				lang:'',
				brand:''
			}
		}
	}
}
</script>

<style>
</style>
